import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading_container" >
      <span class="loading-spinner"></span>
    </div>
  );
};

export default Loading;
